import React from 'react';
import { motion } from 'framer-motion';
import { renderToStaticMarkup } from 'react-dom/server';
import he from 'he';

const HeaderAnim = ({ header }) => {
  const headerText = renderToStaticMarkup(header).split('<br/>');
  const animDuration = 0.02;
  let totalDuration = 0;

  headerText.map((t, i) => {
    totalDuration = totalDuration + animDuration * t.split(" ").length;
  });

  const variants = {
    hidden: {
      opacity: 0,
      transition: { staggerChildren: animDuration, duration: totalDuration }
    },
    visible: {
      opacity: 1,
      transition: { staggerChildren: animDuration, duration: totalDuration }
    }
  };

  const innerText = headerText.map((text, index) => {
    const textAnim = [];
    for (let i = 0; i < he.decode(text).length; i++) {
      textAnim.push(<motion.span key={text + '-' + index + '-' + i} variants={variants}>
        {he.decode(text)[i]}
      </motion.span>);
    }
    textAnim.push(<br key={index + 'br-' + index} />);
    return <span className="word-wrap" key={text + 'br-' + index}>{textAnim}</span>;
  });

  return <motion.span
    initial="hidden"
    animate="visible"
    exit="hidden"
    variants={variants}>
    {innerText}
  </motion.span >;
};
export default HeaderAnim;